(function () {
  'use strict';

  angular
    .module('app.cart.identification', [])

    .directive('cartIdentification', function () {
      return {
        restrict: 'A',
        bindToController: {
          step: '<'
        },
        controllerAs: 'cartCtrl',
        /* @ngInject */
        controller: ["LogService", "AppService", "RoutesService", "CartService", function (LogService, AppService, RoutesService, CartService) {
          var ctrl = this;

          getCart();

          // Functions

          function getCart() {
              AppService.getParams()
              .then(function (data) {
                if (data.HasCart) {
                  CartService.update(ctrl, data, true);
                  setNextLink();
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function setNextLink() {
            CartService.updateStepsCart(ctrl);

            var _routes = RoutesService.get(),
              route = ctrl.isNumericCart ? _routes.CartPayment.url : _routes.CartShipping.url;
            route = ctrl.cart.RestToPay === 0 ? _routes.CartValidation.url : route;
            LogService.redirect = {
              url: route
            };
          }

        }]
      };
    });

})();
